import axios from "axios";

const BUILD_URL = process.env.REACT_APP_BACKEND_URL;
// Same-origin when the site is opened on the www/apex twin of the backend host (avoids CORS block).
const sameSite = (() => {
  try {
    const b = new URL(BUILD_URL).hostname.replace(/^www\./, "");
    return window.location.hostname.replace(/^www\./, "") === b;
  } catch { return false; }
})();
const BACKEND_URL = sameSite ? window.location.origin : BUILD_URL;
export const API_ROOT = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
});

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}

export function formatApiError(detail) {
  if (detail == null) return "حدث خطأ، حاول مرة أخرى";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
